import { useLocation, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useMemo, useState } from "react";

export const useTabQuery = (tabs) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { tabIndex, tabParam, validTab } = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get("tab");
    const tabIndex = tabs.findIndex((tab) => tab.key === tabParam);
    return {
      tabParam,
      tabIndex,
      validTab: tabParam ? tabIndex !== -1 : true,
    };
  }, [location.search, tabs]);

  const [selectedIndex, setSelectedIndex] = useState(tabIndex !== -1 ? tabIndex : 0);

  const handleTabChange = useCallback(
    (index) => {
      if (index === selectedIndex) return;
      setSelectedIndex(index);

      const selectedTabKey = tabs[index]?.key;
      if (selectedTabKey) {
        const queryParams = new URLSearchParams(location.search);
        queryParams.set("tab", selectedTabKey);
        navigate({ search: queryParams.toString() }, { replace: true });
      }
    },
    [tabs, selectedIndex, location.search, navigate]
  );

  useEffect(() => {
    if (tabIndex !== -1 && tabIndex !== selectedIndex) {
      setSelectedIndex(tabIndex);
    }
  }, [tabIndex]);

  return {
    selectedIndex,
    handleTabChange,
    validTab,
  };
};
